import React from 'react';
import { BookOpenIcon, ClockIcon, FolderCheckIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  clock: ClockIcon,
  book: BookOpenIcon,
  route: RouteIcon,
  folder: FolderCheckIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-brand-navy" data-id="element-16" data-mp="3no9ksomqmxns">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="38risezbhem7o">
        <h2 id="beneficios" className="font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-18" data-mp="38udbameujyyz">
          ¿Qué puede cambiar cuando empiezas?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-white/80" data-id="element-19" data-mp="2ztouxl1zdmix">
          Una planificación organizada puede simplificar tus clases.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="y0ip7xc2zoms">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg bg-brand-surface p-2.5 text-left" data-id="element-21" data-mp="2bee4dtliccic" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-brand-sky" data-id="element-22" data-mp="2l4h4edr1qqq6">
                  <Icon size={15} className="text-brand-navy" data-id="element-23" data-mp="2g6nvve29tkmq" />
                </span>
                <div data-id="element-24" data-mp="1sgtld35fc85n">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight text-brand-yellow" data-id="element-25" data-mp="1si4r38ifjpze">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-white/80" data-id="element-26" data-mp="22g2anipcgylo">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}